export default "__VITE_ASSET__CpoaHYw___"